// src/components/shared/SearchInput.js
import React from 'react';
import styled from 'styled-components';

const SearchBox = styled.input`
  padding: 10px;
  font-size: 16px;
  width: 300px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 5px;
`;

const SearchInput = ({ value, onChange }) => {
  return (
    <SearchBox
      type="text"
      placeholder="Search settings..."
      value={value}
      onChange={onChange}
    />
  );
};

export default SearchInput;
